module.exports = __webpack_public_path__ + "img/arrow-right-template.a16e79df.svg";